import { getDurationFromCount, getDurationInDays } from "../../../../actions/v2/CalendarActions";
import moment from "moment";

export const getIsAllDay = (start, end) => {
  return true;
};

export const getOutsourceStatus = (sites) => {
  return sites.every((site) =>
    site.tasks.every((task) => task.outsource_status === 1)
  ) === true
    ? 1
    : 0;
};

export const getJobState = (sites) => {
  return sites && Array.isArray(sites) && sites.length && sites[0].state
    ? sites[0].state
    : "";
};

export const getJobTasks = (tasks) => {

  const formattedTasks = [];
  tasks.forEach((task) => {
    const {
      // id,
      // job_id,
      quote_task_id,
      task_id,
      // quote_id,
      // scope_doc_id,
      // service_agent_id,
      task_start_date,
      task_end_date,
      task_initial_cost,
      task_outsourced_cost,
      // task_title,
      task_status,
      // job_task_label,
      task_label,
      description,
      task_amount,
      // invoice_generated,
      // invoice_number,
      // xero_invoice_state,
      task_invoice_id,
      contractor_details,
      estimate,
      estimated_cost,
      additional_cost_details,
      task_additional_total_cost,
      task_name,
      task_state,
      area_name,
      job_task_label,
      assignee_id,
      assignee_name,
      outsourced_notes,
      outsourced_task_cost,
      task_cost

    } = task;

    let assigneeDetails = [{
      "id": assignee_id,
      "org_id": assignee_id,
      "notes": outsourced_notes,
      "outsourced_budget": outsourced_task_cost,
      "contractor_name": assignee_name,
      "contractor_task_status": task_status,
      "previous_contractor_task_status": null,
      "organisation_type": null,
    }]

    formattedTasks.push({
      taskId: task_id,
      id: quote_task_id,
      status: task_status,
      start: task_start_date,
      end: task_end_date,
      contractors: contractor_details,
      taskLabel: task_label,
      taskInvoiceId: task_invoice_id,
      taskDescription: description,
      taskAmount: task_initial_cost,
      outsourcedAmount: task_outsourced_cost,
      estimate: estimate,
      estimateValue: estimated_cost,
      additionalCostDetails: additional_cost_details,
      totalAdditionalCost: task_additional_total_cost,
      taskName: task_name,
      task_state: task_state,
      areaName: area_name,
      jobTaskLabel: job_task_label,
      assigneeDetails: assigneeDetails,
      taskCost: task_cost
    });
  });

  return formattedTasks;
};

export const getEventModifyableStatus = (tasks, roleType) => {
  return roleType === "admin"
    ? !tasks.every((task) => task.status >= 7)
    : !tasks.some((task) => task.status >= 7);
};


export const serializeJobs = (jobs, isSingleJob = false) => {
  const serializedJobs = jobs.map((jobItem) => {
    const {
      job_id,
      acc_manager_user_name,
      total_job_amount,
      total_outsourced_budget_to_contractor,
      total_allocated_budget_to_acc_manager,
      account_manager_name,
      job_board_tasks,
      task_frequencies,
      job_state,
      invoice_number,
      job_start_date,
      job_end_date,
    } = jobItem;

    let tasks = [];
    if (isSingleJob) {
      tasks = getJobTasks(task_frequencies ? task_frequencies : jobItem.tasks);
    }

    let job = {
      id: job_id,
      accountManagerUsername: acc_manager_user_name,
      isJob: true,
      invoice_number: invoice_number
    };

    if (job_start_date && job_end_date) {
      let start = moment(job_start_date);
      let end = moment(job_end_date);
      let dayCount = moment(end).diff(start, "days") + 1;
      // let duration = getDurationFromCount(dayCount, start.month());
      let duration = getDurationInDays(dayCount);
      let stamp = moment(start).unix();
      job.start = moment(start).format("DD/MM/YYYY");
      job.end = moment(end).format("DD/MM/YYYY");
      job.dayDuration = dayCount;
      job.duration = duration;
      job.dayStamp = stamp;
    }


    if (isSingleJob) {
      job.tasks = tasks;
      job.quoteTotal = total_job_amount;
      job.totalOutsourceBudget = total_outsourced_budget_to_contractor;
      // job.orgId = org_id;
      job.job_start_date = job_start_date;
      job.job_end_date = job_end_date;
      job.jobState = job_state;
      job.totalAllocatedBudget = total_allocated_budget_to_acc_manager;
      job.accountManagerName = account_manager_name;
      job.jobBoardTasks = job_board_tasks
    }
    return job;
  });

  return serializedJobs;
};

export const serializeResourcingTasks = (jobs, isSingleJob = false) => {
  const serializedJobs = jobs.map((jobItem) => {
    const {
      job_id,
      acc_manager_user_name,
      total_job_amount,
      total_outsourced_budget_to_contractor,
      total_allocated_budget_to_acc_manager,
      account_manager_name,
      allocated_managers,
      job_board_tasks,
      task_frequencies,
      job_state,
      invoice_number,
      job_start_date,
      job_end_date,
      job_number
    } = jobItem;

    let tasks = [];
    if (isSingleJob) {
      tasks = getJobTasks(task_frequencies ? task_frequencies : jobItem.tasks);
    }

    let job = {
      id: job_id,
      accountManagerUsername: acc_manager_user_name,
      isJob: true,
      invoice_number: invoice_number
    };

    if (job_start_date && job_end_date) {
      let start = moment(job_start_date);
      let end = moment(job_end_date);
      let dayCount = moment(end).diff(start, "days") + 1;
      // let duration = getDurationFromCount(dayCount, start.month());
      let duration = getDurationInDays(dayCount);
      let stamp = moment(start).unix();
      job.start = moment(start).format("DD/MM/YYYY");
      job.end = moment(end).format("DD/MM/YYYY");
      job.dayDuration = dayCount;
      job.duration = duration;
      job.dayStamp = stamp;
    }


    if (isSingleJob) {
      job.tasks = tasks;
      job.quoteTotal = total_job_amount;
      job.totalOutsourceBudget = total_outsourced_budget_to_contractor;
      // job.orgId = org_id;
      job.job_start_date = job_start_date;
      job.job_end_date = job_end_date;
      job.jobState = job_state;
      job.totalAllocatedBudget = total_allocated_budget_to_acc_manager;
      job.accountManagerName = account_manager_name;
      job.jobBoardTasks = job_board_tasks;
      job.jobLabel = job_number;
      job.account_managers = allocated_managers
    }

    return job;
  });

  return serializedJobs;
};

export const getJobStates = (jobs) => {
  const statesList = [];
  jobs.forEach((job) =>
    job.sites.forEach((site, index) => {
      statesList.push({
        id: index + 1,
        name: site.state ? site.state : "",
      });
    })
  );

  const uniqueStates = [
    ...new Set(
      statesList.map((stateItem) => stateItem.name.trim().toLowerCase())
    ),
  ];
  const statesData = uniqueStates.map((state, index) => ({
    name: state,
    id: index + 1,
  }));

  return statesData;
};
